import ra1 from "../../images/svg/ra-1.svg";
import ra2 from "../../images/svg/ra-2.svg";
import ra3 from "../../images/svg/ra-3.svg";
import ra4 from "../../images/svg/ra-4.svg";

export const activityIcons = {
  WAIVER_SIGNED: ra1,
  QUICK_WAIVER_SIGNED: ra1,
  WAIVER_NOT_APPROVED: ra2,
  WAIVER_NOT_APPROVED_BY_GUARDIAN: ra2,
  MINOR_BLOCKED: ra3,
  GUARDIAN_APPROVAL_COMPLETED: ra4,


  WAIVER_PUBLISHED: ra1,
  WAIVER_NEW_VERSION_PUBLISHED: ra1,
  WAIVER_ARCHIVED: ra2,
};

export const getActivityContent = (activity) => {
  switch (activity.activityType) {

    case "WAIVER_SIGNED":
      return {
        text: (
          <>
            <span className="text-darkLighted font-medium">
              {activity.customerName || "Customer"}
            </span>
            {" signed "}
            <span className="text-darkLighted font-medium">
              {activity.waiverName || "waiver"}
            </span>
          </>
        ),
      };

    case "QUICK_WAIVER_SIGNED":
      return {
        text: (
          <>
            <span className="text-darkLighted font-medium">
              {activity.customerName || "Customer"}
            </span>
            {" signed "}
            <span className="text-darkLighted font-medium">
              {activity.waiverName || "waiver"}
            </span>
            {" (Quick Waiver)"}
          </>
        ),
      };

    case "WAIVER_NOT_APPROVED":
      return {
        text: (
          <>
            <span className="text-darkLighted font-medium">
              {activity.customerName || "Customer"}
            </span>
            {" was not approved for "}
            <span className="text-darkLighted font-medium">
              {activity.waiverName || "waiver"}
            </span>
          </>
        ),
      };

    case "WAIVER_NOT_APPROVED_BY_GUARDIAN":
      return {
        text: (
          <>
            <span className="text-darkLighted font-medium">
              {activity.guardianName || "Guardian"}
            </span>
            {" did not approve "}
            <span className="text-darkLighted font-medium">
              {activity.customerName || "minor"}
            </span>
          </>
        ),
      };

    case "MINOR_BLOCKED":
      return {
        text: (
          <>
            Minor blocked from signing waiver for{" "}
            <span className="font-semibold text-dark">
              {activity.customerName}
            </span>
          </>
        ),
      };

    case "GUARDIAN_APPROVAL_COMPLETED":
      return {
        text: (
          <>
            Guardian{" "}
            <span className="font-semibold text-dark">
              {activity.guardianName}
            </span>{" "}
            approved waiver for{" "}
            <span className="font-semibold text-dark">
              {activity.customerName}
            </span>
          </>
        ),
      };


    case "WAIVER_PUBLISHED":
      return {
        text: (
          <>
            <span className="text-darkLighted font-medium">
              {activity.waiverName || "Waiver"}
            </span>
            {" was published"}
            {activity.locationName?.trim() && (
              <>
                {" at "}
                <span className="text-darkLighted font-medium">
                  {activity.locationName.trim()}
                </span>
              </>
            )}
            {"."}
          </>
        ),
      };

    case "WAIVER_NEW_VERSION_PUBLISHED":
      return {
        text: (
          <>
            <span className="text-darkLighted font-medium">
              {activity.waiverName || "Waiver"}
            </span>
            {" new version was published"}
            {activity.locationName?.trim() && (
              <>
                {" at "}
                <span className="text-darkLighted font-medium">
                  {activity.locationName.trim()}
                </span>
              </>
            )}
            {"."}
          </>
        ),
      };
    
    case "WAIVER_ARCHIVED":
      return {
        text: (
          <>
            <span className="text-darkLighted font-medium">
              {activity.waiverName || "Waiver"}
            </span>
            {" was archived"}
            {activity.locationName?.trim() && (
              <>
                {" at "}
                <span className="text-darkLighted font-medium">
                  {activity.locationName.trim()}
                </span>
              </>
            )}
            {"."}
          </>
        ),
      };



    default:
      return {
        text: activity.title || "Activity",
      };
  }
};